<script>
import ArtistList from './ArtistList.vue';
import Logo from "../../images/logo.svg";
import bannerAppIcon from "../../images/mobile-apps-banner-app-icon.svg";
import Loading from 'vue-loading-overlay'
export default {
	props: ["currentUser", "currentUserAvatar", "isProd", "packagePrice", "city", "country", "artType"],
	data() {
		return {
			Logo: Logo,
			bannerAppIcon: bannerAppIcon,
			userMessage: "",
			showArtists: false,
			loading: false,
			domain: window.location.origin,
			header: '',
      artists: []
		}
	},
	mounted() {
		const searchQuery = localStorage.getItem("searchQuery")
		if(searchQuery) {
			this.userMessage = searchQuery || ""
			this.sendMessage()
		}
		localStorage.removeItem("searchQuery")
	},
	methods: {
		async sendMessage() {
			if (!this.userMessage) return;
			this.loading = true
			let generatingResults = document.getElementById("generating-results");
			let inpt = document.getElementById("inpt");
			inpt.disabled = true;
			generatingResults.innerHTML ="Generating results..."
			let chatContainer = document.getElementById("chat-container");

			let userMessageContainer = document.createElement("div");
			userMessageContainer.classList.add("d-flex", "align-items-start", "user", "chat");

			let userImg = document.createElement("img");
			userImg.src = this.currentUserAvatar ? this.currentUserAvatar : `${this.domain}/images/default-avatar-img.jpg`;
			userImg.alt = this.currentUser ? this.currentUser : "avatar";
			userImg.classList.add("img-w", "user-img");

			let userMessage = document.createElement("h5");
			userMessage.classList.add("ms-2", "user-chat");
			userMessage.innerText = this.userMessage;
			userMessageContainer.appendChild(userImg);
			userMessageContainer.appendChild(userMessage);
			chatContainer.appendChild(userMessageContainer);
			chatContainer.scrollTo({ top: chatContainer.scrollHeight, behavior: "smooth" });
			let message = this.userMessage
			this.userMessage = ""
			this.$axios.post('/ai', { message: message })
			.then(response => {
				const data = response.data;
				this.artists = data.artists;
				
				let aiMessageContainer = document.createElement("div");
				aiMessageContainer.classList.add("d-flex", "align-items-start", "chat");

				let aiImg = document.createElement("img");
				aiImg.src = this.bannerAppIcon;
				aiImg.alt = "banner app icon";
				aiImg.classList.add("img-w");

				let aiMessage = document.createElement("p");
				aiMessage.classList.add("ms-2");
				aiMessage.innerHTML = data.message.replace(/\n/g, "<br>");
				aiMessageContainer.appendChild(aiImg);
				aiMessageContainer.appendChild(aiMessage);
				chatContainer.appendChild(aiMessageContainer);
				let userMessageTop = (chatContainer.scrollHeight - 55) - (userMessageContainer.clientHeight + aiMessage.clientHeight)
				chatContainer.scrollTo({ top: userMessageTop, behavior: "smooth" });
				this.header = ''
				if (this.artists.length > 0) {
					this.header = data.message.split(":")[0]
					this.showArtists = true
				}
				this.loading = false
				inpt.disabled = false;
				generatingResults.innerHTML ="Ask anything"
			}).catch(error => {
				generatingResults.innerHTML ="Ask anything"
				this.loading = false
				inpt.disabled = false;
			})
		},
	},
	components: {
		ArtistList,
		Loading
	}
}
</script>
<template>
	<div class="ai">
		<section class="ai-chat">
			<div>
				<div class="d-flex align-items-center mb-4">
					<img :src="Logo" alt="logo" />
					<h5 style="margin: unset;" id="generating-results" class="ms-2">Soul Artists AI (<span style="color: #ff8141">beta</span>)</h5>
				</div>
				<div class="ms-3"><p>What kind of <span style="color: #ff8141">live entertainment</span> are you looking for?</p></div>
				<div class="chats ms-3" id="chat-container">
					<loading :active.sync="loading"
						:can-cancel="false"
						:is-full-page="false"
						color="#FF8141"
						style="position: absolute; z-index: 999;"
					></loading>
				</div>
				<div class="input-container ai-chat__input">
					<input
						v-model="userMessage"
						type="text"
						class="inpt"
						id="inpt"
						@keyup.enter="sendMessage"
						placeholder="Send a message..."
					/>
					<svg @click="sendMessage" class="send-icon" xmlns="http://www.w3.org/2000/svg" width="22" height="21" fill="none" viewBox="0 0 22 21">
						<path fill="#E58F66" d="M2 18L18 10.5L2 3V7.5L13 10.5L2 13.5V18Z"/>
					</svg>
				</div>
			</div>
		</section>
		<ArtistList 
			:artists="artists" 
			:showArtists="showArtists"
      :isProd="isProd"
			:city="city"
			:country="country"
			:header="header"
			:artType="artType"
			:packagePrice="packagePrice"
		/>
	</div>
</template>